/**
 * Fetches the cost information of a notary with by his ID from remote server.
 */
export async function getCostInformationByPersonId() {
  return fetch('/cost-information/', {
    method: 'GET'
  }).then((response) => {
    return response.json();
  });
}
